<template>
	<div id="app" style="width:90%">
		<el-button type="primary" size="small" style="margin:1%" round @click="editialogVisible()">新增角色</el-button>
		<el-table :data="roleData" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
		 element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column prop="roleId" label="序号" sortable align="center">
			</el-table-column>
			<el-table-column prop="roleName" label="用户名" align="center">
			</el-table-column>
			<el-table-column prop="remark" label="角色备注" align="center">
			</el-table-column>
			<el-table-column prop="createDate" label="创建时间" align="center">
			</el-table-column>
			<el-table-column  label="操作"  fixed="right" align="center">
		　　　　<template slot-scope="scope">
		　　　　　　<el-button size="small" type="text" @click="editialogVisible(scope.row.roleId)">编辑</el-button>
		　　　　　　<el-button size="small" type="text" @click="toDeleteRole(scope.row.roleId)">删除</el-button>
		　　　　　　<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.roleId)">授权</el-button>
		　　　　</template>
		　　</el-table-column>
		</el-table>

		<!-- 编辑和新增 -->
		<el-dialog style="float:rigin" :title="popTile" :visible.sync="dialogVisible" width="35%" :close-on-click-modal="false">
			<div class="app-container">
				<el-form ref="form" :model="form" :rules="mainFormRules" :label-width="formLabelWidth" size="medium">
					<el-form-item :label-width="formLabelWidth" label="角色名称:">
						<el-col :span="8">
							<el-input v-model="form.roleName" placeholder="请输入角色名" />
						</el-col>
					</el-form-item>

					<el-form-item :label-width="formLabelWidth" label="角色备注:">
						<el-col :span="10">
							<el-input v-model="form.remark" placeholder="请输入备注" />
						</el-col>
					</el-form-item>

					<el-form-item>
						<el-button :loading="editLoading" type="primary" @click="edit()">提交</el-button>
						<el-button @click="dialogVisible = false">取 消</el-button>
						<!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>

		<!-- 授权 -->
		<el-dialog style="float:rigin" title="授权" :visible.sync="dialogVisibleMenus" width="35%">
			<div class="app-container" style="text-align: center;">
				<el-tree ref="tree" :data="jurisdiction" :props="defaultProps" default-expand-all show-checkbox node-key="id"
				 :default-checked-keys="defaultMmenuIds" />
				<span slot="footer" class="dialog-footer">
					<el-button @click="cannelDialogVisibleMenus">取 消</el-button>
					<el-button type="primary" @click="insertRoleFunctionFun" :loading="insertRoleFunctionFunLoading">确 定</el-button>
				</span>

			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
                popTile:'新增',
				loading: false,
				roleData: [{}], //角色列表
				jurisdiction: [{}], //权限列表

				dialogVisible: false, //编辑弹框
				dialogVisibleMenus: false, // 授权弹窗

				defaultProps: {
					label: 'fname',
					children: 'manageFunctionList'
				},
				ids: '', //授权用户id
				formLabelWidth: "200px",
				form: {
					roleName: "",
					remark: ""
				},
				defaultMmenuIds: [],
				mainFormRules: {
					roleName: {
						required: true,
						message: "请输入角色名",
						trigger: "blur"
					},
				},

				editLoading: false,
				insertRoleFunctionFunLoading : false,
			};
		},
		methods: {
			// 删除父元素
			checked(id, data, newArr) {
				data.forEach(item => { //遍历组成树结构的数据
					if (item.id == id) { //需要显示的如果有父元素的节点
						// 当子节点数组为数组[]时用  item.childList.length==0  childList是子节点的数组名
						// 当子节点为空是后台传的为null时用  item.childList==null
						if (item.children == null) {
							newArr.push(item.id) //把这个数据添加
						}
					} else { //需要显示的没有父元素的节点但是有子节点
						if (item.children != null) {;
							this.checked(id, item.children, newArr)
						}
					}
				})
			},
			//关闭授权弹框
			cannelDialogVisibleMenus() {
				this.dialogVisibleMenus = false
				this.defaultMmenuIds = []
			},
			// 打开授权
			dialogVisibleFun(id) {
				this.defaultMmenuIds = []
				this.$nextTick(function() {
					this.$refs.tree.setCheckedKeys([]);
				})
				this.ids = id
				this.$api.findMenusById(id).then((res) => {
					if (res.state == 'success') {
						var newArr = [] //需要展示的数据
						var item = ''
						res.data.forEach(item => {
							this.checked(item.id, this.jurisdiction, newArr)
						});
						this.defaultMmenuIds = newArr //需要展示的数据

					}
				})
				this.dialogVisibleMenus = true;
			},
			//编辑弹框
			editialogVisible(id) {
                this.form.roleName = ''
                this.form.remark = ''
				if (id) {
					//编辑
					this.ids = id
                    this.findRoleById(id);
                    this.popTile = '编辑'
				}
				this.dialogVisible = true;
			},
			edit() { //新增角色权限列表
				this.editLoading = true;
				if (this.ids) {
					//编辑
					let data = {
						roleId: this.ids,
						roleName: this.form.roleName,
						remark: this.form.remark
					}
					this.$api.editRole(data).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.dialogVisible = false;
							this.queryManageRoleWhere();
						} else {
							this.$message.error(res.message);
						}
						this.editLoading = false;
					})
				} else {
					//添加
					let data = {
						roleName: this.form.roleName,
						remark: this.form.remark
					}
					this.$api.insertRole(data).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.dialogVisible = false;
							this.queryManageRoleWhere();
						} else {
							this.$message.error(res.message);
						}
						this.editLoading = false;
					})
				}
			},
			//根据id查询角色
			findRoleById(id) {
				this.$api.findRoleById(id).then((res) => {
					if (res.state == 'success') {
						this.form.roleName = res.data.roleName
						this.form.remark = res.data.remark
					}
				})
			},
			//角色列表
			queryManageRoleWhere() {
				this.$api.queryManageRoleWhere().then((res) => {
					if (res.state == 'success') {
                        // console.log('数据--',res)
						this.roleData = res.data
					}else{
                        this.$message.error(res.message);
                    }
				})
			},
			//删除角色
			toDeleteRole(id) {
				// console.log(id);
				this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.deleteRole(id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.queryManageRoleWhere();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			//角色权限列表
			findManageFunctionFun() {
				this.$api.findManageFunction().then((res) => {
					if (res.state == 'success') {
						this.jurisdiction = res.data
						// console.log(this.jurisdiction)
					}
				})
			},
			//设置编辑权限
			insertRoleFunctionFun() {
				// let arr = [];
				// let arrIndex = 0
				// for (let i = 0; i < this.$refs.tree.getCheckedNodes().length; i++) {
				//     arr[arrIndex++] = this.$refs.tree.getCheckedNodes()[i].id
				// }
				let parentArr = this.$refs.tree.getHalfCheckedKeys() //通过 key 获取 半选中
				let childeArr = this.$refs.tree.getCheckedKeys() //通过 key 获取 选中的
				let arr = childeArr.concat(parentArr) //全部选中的
				let data = {
					"roleId": this.ids,
					"functionIdArray": arr
				}
				this.insertRoleFunctionFunLoading = true;
				this.$api.insertRoleFunction(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleMenus = false;
					} else {
						this.$message.error(res.message);
					}
					this.insertRoleFunctionFunLoading = false;
				})
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
		},
		created() {
			this.findManageFunctionFun();
			this.queryManageRoleWhere();
		}
	};
</script>

<style>
</style>
